import {
  AdminPaymentActionTypes,
  ADMIN_PAYMENT_FAIL,
  ADMIN_PAYMENT_LOADING,
  ADMIN_PAYMENT_SUCCESS,
  AdminPaymentState,
  ADMIN_PAYMENT_UPDATE_API_MSG,
  ADMIN_PAYMENT_UPDATE_API_RES,
} from "./ActionTypes";
import { AdminPaymentResponse } from "./Model";

const initialStateGetPosts: AdminPaymentState = {
  loading: false,
  adminPaymentRes: {} as AdminPaymentResponse,
  message: "",
  status: 0,
};
export const adminPaymentReducer = (
  state = initialStateGetPosts,
  action: AdminPaymentActionTypes
): AdminPaymentState => {
  switch (action.type) {
    case ADMIN_PAYMENT_LOADING:
      return {
        ...state,
        loading: true,
        adminPaymentRes: {} as AdminPaymentResponse,
      };
    case ADMIN_PAYMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        adminPaymentRes: action.payload,
      };
    case ADMIN_PAYMENT_FAIL:
      return {
        ...state,
        loading: false,
        adminPaymentRes: {} as AdminPaymentResponse,
        message: action.message,
        status: action.status,
      };
    case ADMIN_PAYMENT_UPDATE_API_MSG:
      return {
        ...state,
        loading: false,
        adminPaymentRes: action.payload,
        message: action.message,
        status: action.status,
      };
    case ADMIN_PAYMENT_UPDATE_API_RES:
      return {
        ...state,
        loading: false,
        adminPaymentRes: {} as AdminPaymentResponse,
        message: action.message,
        status: action.status,
      };
    default:
      return state;
  }
};
